<template>
  <div v-if="isVisible">
    <div
      class="backdrop"
      v-if="isVisible"
      @click="closeSearchBox"
    ></div>
    <div v-if="isVisible" class="search-container">
      <div class="search-box">
        <button class="close-btn" @click="closeSearchBox">&times;</button>
        <input
          ref="searchInput"
          type="text"
          v-model="query"
          placeholder="Looking for..."
          @keyup="handleInput"
        />
        <div class="resultBox">
          <ul>
            <li
              class="result-item"
              v-for="(suggestion, index) in filteredSuggestions"
              :key="index"
              @click="selectSuggestion(suggestion)"
            >
              {{ suggestion.name }}
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>
  <a
    text
    class="mr-2 ml-2 fw-normal"
    :style="{ fontSize: fontSize + 'px' }"
    @click="openSearchBox" 
    v-else
    ><i class="fas fa-search"></i> Search
  </a>
</template>

<script>
import { IMPROVE_CONFIG } from '@/config.js';
import NewCourseList from '@/../public/static/newcourselist.json';

export default {
  props: {
    fontSize: {
      type: [String, Number], // Allow both string and number types
      default: 14, // Default font size
    },
  },
  data() {
    return {
      query: "",
      isActive: false,
      isVisible: false, // Set to false initially to hide the box
      directUrl: IMPROVE_CONFIG.DIRECT_URL,
      suggestions: [],
      filteredSuggestions: [],
      NewCourseList: this.NewCourseList,
    };
  },
  created() {
    this.suggestions = [
      // pages 
      { name: "Why Improve?", url: "/why-improve" },
      { name: "Features", url: "/features" },
      { name: "Pricing", url: "/pricing" },
      { name: "Request a Demo", url: "/contact" },
      { name: "Partner Programme", url: "/partner-programme" },
      { name: "About us", url: "/about-us" },
      { name: "HR Integrations", url: "/hr-integrations"},
      { name: 'Cyber Security', url: this.directUrl +'/#/courses/cyber-security'},
      { name: 'Free Trial', url: this.directUrl +'/#/signup?ref=website' },
      { name: 'Try for Free', url: this.directUrl +'/#/signup?ref=website' },
      { name: 'Contact Us', url: '/contact' },
      { name: 'FAQ', url: '/FAQ' },


      // Blog
      { name: "Blog", url: "/blog" },
      { name: "The Business Case for Outsourced HR Partners", url: "/blog/the-business-case-for-outsourced-hr-partners" },
      { name: "Birth of Mobile Phone Learning", url: "/blog/birth-of-mobile-phone-learning" },
      { name: "SME Companies can Succeed through Outsourcing", url: "/blog/how-in-an-ever-changing-world-sme-companies-can-succeed-through-outsourcing" },
      { name: "Learning and Development Vital SME Business Growth", url: "/blog/learning-and-development-vital-sme-business-growth" },
      { name: "SME Outsource Learning and Development", url: "/blog/sme-outsource-learning-and-development" },
      { name: "Outsourcing HR Company", url: "/blog/when-should-an-outsourcing-hr-company-add-ld-to-its-portfolio" },
      { name: "SMEs in Developing their People", url: "/blog/what-are-the-benefits-for-smes-in-developing-their-people" },
    ];

    // Extract courses from the nested JSON structure
    const extractCourses = (category) => {
      return Object.values(category)
        .filter((item) => item.title) // Ensure it has a title
        .map((item) => ({
          name: item.title, // Map title to name
          url: `/course/${item.id}`, // Dynamically construct the URL
          description: item.description, // Add description if available
        }));
    };

    // Loop through top-level keys in the JSON and extract courses
    Object.keys(NewCourseList).forEach((key) => {
      if (typeof NewCourseList[key] === "object") {
        const category = NewCourseList[key];
        const courses = extractCourses(category);
        this.suggestions.push(...courses); // Add extracted courses to suggestions
      }
    });
  },
  destroyed() {
    this.suggestions = [];
  },
  methods: {
    handleInput() {
      const userInput = this.query.toLowerCase().trim();
      if (userInput) {
        const regex = new RegExp(userInput, "i");
        this.filteredSuggestions = this.suggestions.filter((item) =>
          regex.test(item.name) || regex.test(item.description)
        );
        this.isActive = this.filteredSuggestions.length > 0;
      } else {
        this.filteredSuggestions = [];
        this.isActive = false;
      }
    },
    selectSuggestion(suggestion) {
      this.query = suggestion.name;
      this.isActive = false;
      this.closeSearchBox();
      this.$emit("select", suggestion);

      if (suggestion.url.includes('http')) {
        window.open(suggestion.url);
      } else {
        this.$router.push(suggestion.url);
      }
    },
    closeSearchBox() {
      this.isVisible = false;
      this.query = "";
      this.filteredSuggestions = [];
    },
    openSearchBox() {
      this.isVisible = true;
      this.$nextTick(() => {
        this.$refs.searchInput.focus(); // Focus on the input after the DOM is updated
      });
    },
  },
};
</script>

<style scoped>
.backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  z-index: 1000;
}

@keyframes slideDown {
  0% {
    transform: translate(-50%, -100%);
    top: 0;
    opacity: 0;
  }
  100% {
    transform: translate(-50%, -50%);
    top: 23%;
    opacity: 1;
  }
}

.search-container {
  position: fixed;
  top: 0; /* Start at the top */
  left: 50%;
  transform: translate(-50%, -100%); /* Initial position for animation */
  z-index: 1001;
  width: 90%;
  max-width: 500px;
  height: 200px;
  animation: slideDown 0.5s ease-out forwards; /* Animation applied */
}

.search-box {
  background: #fff;
  border-radius: 5px;
  box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.2);
}

.search-box input {
  width: 100%;
  padding: 10px 15px;
  border: 1px solid #ccc;
  border-radius: 5px;
  font-size: 16px;
}

.resultBox {
  max-height: 150px; /* Set a maximum height */
  max-width: 100%; /* Set a maximum width */
  overflow-x: auto; /* Enable horizontal scrolling */
  overflow-y: auto; /* Enable vertical scrolling */
}

/* Custom Scrollbar Styling */
.resultBox::-webkit-scrollbar {
  width: 10px; /* Width of the vertical scrollbar */
  height: 10px; /* Height of the horizontal scrollbar */
}

.resultBox::-webkit-scrollbar-thumb {
  background-color: #888; /* Color of the scrollbar thumb */
  border-radius: 10px; /* Rounded edges for the scrollbar thumb */
}

.resultBox::-webkit-scrollbar-track {
  background: #f1f1f1; /* Background of the scrollbar track */
  border-radius: 10px; /* Optional: Rounded track edges */
}

.resultBox ul {
  list-style: none;
  padding: 0;
  margin: 0;
}

.resultBox li {
  padding: 8px 12px;
  cursor: pointer;
  border-radius: 5px;
  transition: background 0.3s;
  text-wrap: wrap;
}

.resultBox li:hover {
  background: #f4f4f4;
}

.close-btn {
  position: absolute;
  top: 5px;
  right: 10px;
  background: none;
  border: none;
  font-size: 24px;
  font-weight: bold;
  cursor: pointer;
  color: #333;
}

.result-item{
  font-size: 0.9rem;
  text-align: left;
}
</style>
